import { forwardRef } from 'react'

const Button = forwardRef(({ 
  children, 
  variant = 'primary', 
  size = 'medium', 
  disabled = false, 
  loading = false,
  className = '',
  onClick,
  type = 'button',
  ...props 
}, ref) => {
  const baseClasses = 'font-light transition-all duration-300 transform active:scale-95 focus:outline-none focus:ring-2 focus:ring-offset-2'
    
  const variants = {
    primary: 'bg-primary-black text-white hover:bg-primary-black/50 focus:ring-primary-text',
    secondary: 'border-2 border-primary-text text-primary-text hover:bg-primary-text hover:text-white focus:ring-primary-text',
    outline: 'border border-primary-gray text-primary-gray hover:bg-primary-gray hover:text-white focus:ring-primary-gray',
    ghost: 'text-primary-text hover:bg-primary-section focus:ring-primary-text border border-primary-text'
  }
    
  const sizes = {
    small: 'px-4 py-2 text-sm',
    medium: 'px-6 py-3 text-base',
    large: 'px-8 py-4 text-lg'
  }
    
  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed transform-none' : 'hover:scale-105'
  const loadingClasses = loading ? 'cursor-wait' : ''
    
  const finalClasses = `${baseClasses} ${variants[variant]} ${sizes[size]} ${disabledClasses} ${loadingClasses} ${className}`
    
  return (
    <button
      ref={ref}
      type={type}
      className={finalClasses}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading ? (
        <div className="flex items-center justify-center">
          <svg className="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Cargando...
        </div>
      ) : (
        children
      )}
    </button>
  )
})

Button.displayName = 'Button'

export default Button